<template :ref="dialog">
  <div>
    <!-- フォーム追加コンポーネント -->
    <v-dialog v-if="formAdd_dialog" v-model="formAdd_dialog">
      <form-SelectAdd
        :formTypes="formTypes"
        v-on:close="formSet"
        :i="i"
        :j="j"
      ></form-SelectAdd>
    </v-dialog>
    <!-- 各コンポーネント -->
    <v-dialog v-if="text_dialog" v-model="text_dialog">
      <text-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :init="form.init"
        :cols="form.cols"
        :size="form.size"
        :rule="form.rule"
        :value="form.value"
        :css="form.css"
      ></text-form>
    </v-dialog>
    <v-dialog v-if="select_dialog" v-model="select_dialog">
      <select-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :init="form.init"
        :cols="form.cols"
        :selectbox="form.selectbox"
        :form_check="form.form_check"
        :rule="form.rule"
        :css="form.css"
      ></select-form>
    </v-dialog>
    <v-dialog v-if="calender_dialog" v-model="calender_dialog">
      <calender-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :cols="form.cols"
        :label="form.label"
        :value="form.value"
        :rule="form.rule"
      ></calender-form>
    </v-dialog>
    <v-dialog v-if="checkbox_dialog" v-model="checkbox_dialog">
      <checkbox-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :cols="form.cols"
        :init="form.init"
        :rule="form.rule"
        :checkbox="checkbox_tmp"
      ></checkbox-form>
    </v-dialog>
    <v-dialog v-if="fileupload_dialog" v-model="fileupload_dialog">
      <fileupload-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :cols="form.cols"
        :init="form.init"
        :file_type="form.file_type"
      ></fileupload-form>
    </v-dialog>
    <v-dialog v-if="image_dialog" v-model="image_dialog">
      <image-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :init="form.init"
        :cols="form.cols"
        :width="form.width"
        :height="form.height"
      ></image-form>
    </v-dialog>
    <v-dialog v-if="worktime_dialog" v-model="worktime_dialog">
      <worktime-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :cols="form.cols"
        :init="form.init"
        :size="form.size"
      ></worktime-form>
    </v-dialog>
    <v-dialog v-if="timeinput_dialog" v-model="timeinput_dialog">
      <timeinput-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :cols="form.cols"
        :rule="form.rule"
        :init="form.init"
      ></timeinput-form>
    </v-dialog>
    <v-dialog v-if="button_dialog" v-model="button_dialog">
      <button-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :init="form.init"
        :cols="form.cols"
        :rule="form.rule"
        :color="form.color"
      ></button-form>
    </v-dialog>
    <v-dialog v-if="subpage_dialog" v-model="subpage_dialog">
      <subpage-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :init="form.init"
        :cols="form.cols"
        :rule="form.rule"
        :value="form.value"
        :css="form.css"
      ></subpage-form>
    </v-dialog>
    <v-dialog v-if="authconf_dialog" v-model="authconf_dialog">
      <authconf-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :cols="form.cols"
        :init="form.init"
        :rule="form.rule"
        :value="form.value"
      ></authconf-form>
    </v-dialog>
    <v-dialog v-if="copybutton_dialog" v-model="copybutton_dialog">
      <copybutton-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :value="form.value"
        :color="form.color"
      ></copybutton-form>
    </v-dialog>
    <v-dialog v-if="sendbutton_dialog" v-model="sendbutton_dialog">
      <sendbutton-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :cols="form.cols"
        :rule="form.rule"
        :value="form.value"
        :color="form.color"
        :init="form.init"
      ></sendbutton-form>
    </v-dialog>
    <v-dialog v-if="deletebutton_dialog" v-model="deletebutton_dialog">
      <deletebutton-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :value="form.value"
        :color="form.color"
      ></deletebutton-form>
    </v-dialog>
    <v-dialog v-if="autoValue_dialog" v-model="autoValue_dialog">
      <autovalue-form
        v-on:clickSubmit="close"
        :label="form.label"
        :type="form.type"
        :position="i"
        :cols="String(form.cols)"
        :value="form.value"
      ></autovalue-form>
    </v-dialog>
    <v-dialog v-if="div_dialog" v-model="div_dialog">
      <div-form
        v-on:clickSubmit="close"
        :label="form.label"
        :cols="Number(form.cols)"
        :position="i"
        :type="form.type"
        :value="form.value"
        :rule="form.rule"
      ></div-form>
    </v-dialog>
    <v-dialog v-if="alldisabled_dialog" v-model="alldisabled_dialog">
      <alldisabled-form
        v-on:clickSubmit="close"
        :label="form.label"
        :cols="Number(form.cols)"
        :position="i"
        :type="form.type"
        :value="form.value"
        :rule="form.rule"
      ></alldisabled-form>
    </v-dialog>
    <v-dialog v-if="backbutton_dialog" v-model="backbutton_dialog">
      <backbutton-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :value="form.value"
        :rule="form.rule"
      ></backbutton-form>
    </v-dialog>
    <v-dialog v-if="space_dialog" v-model="space_dialog">
      <space-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :cols="form.cols"
      ></space-form>
    </v-dialog>
    <v-dialog v-if="qr_dialog" v-model="qr_dialog">
      <qrreader-form
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :cols="form.cols"
        :rule="form.rule"
      ></qrreader-form>
    </v-dialog>
    <v-dialog v-if="plain_dialog" v-model="plain_dialog">
      <plain-text
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :cols="form.cols"
        :value="form.value"
        :rule="form.rule"
      ></plain-text>
    </v-dialog>
    <v-dialog v-if="master_dialog" v-model="master_dialog">
      <master-DataForm
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :init="form.init"
        :cols="form.cols"
        :rule="form.rule"
        :value="form.value"
      ></master-DataForm>
    </v-dialog>
    <v-dialog v-if="varidasion_dialog" v-model="varidasion_dialog">
      <validation-Form
        v-on:clickSubmit="close"
        :label="form.label"
        :cols="Number(form.cols)"
        :position="i"
        :type="form.type"
        :value="form.value"
        :rule="form.rule"
      ></validation-Form>
    </v-dialog>
    <v-dialog v-if="inputchangeForm_dialog" v-model="inputchangeForm_dialog">
      <inputchange-Form
        v-on:clickSubmit="close"
        :label="form.label"
        :cols="Number(form.cols)"
        :position="i"
        :type="form.type"
        :value="form.value"
        :rule="form.rule"
        :init="form.init"
      ></inputchange-Form>
    </v-dialog>
    <v-dialog v-if="masterdataset_dialog" v-model="masterdataset_dialog">
      <master-Dataset
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :init="form.init"
        :cols="form.cols"
        :rule="form.rule"
        :value="form.value"
      ></master-Dataset>
    </v-dialog>
    <v-dialog v-if="tabTitle_dialog" v-model="tabTitle_dialog">
      <tab-Title
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :init="form.init"
        :cols="Number(form.cols)"
        :rule="form.rule"
        :value="form.value"
      ></tab-Title>
    </v-dialog>
    <v-dialog v-if="autoScroll_dialog" v-model="autoScroll_dialog">
      <auto-Scroll
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :init="form.init"
        :cols="form.cols"
        :rule="form.rule"
        :value="form.value"
      ></auto-Scroll>
    </v-dialog>
    <v-dialog v-if="newTab_dialog" v-model="newTab_dialog">
      <new-Tab
        v-on:clickSubmit="close"
        :type="form.type"
        :position="i"
        :label="form.label"
        :init="form.init"
        :cols="form.cols"
        :rule="form.rule"
        :value="form.value"
      ></new-Tab>
    </v-dialog>
  </div>
</template>
<script>
import formSelectAdd from "./Basic/FormSelectAdd";
import textForm from "./TextForm";
import selectForm from "./SelectForm";
import calenderForm from "./CalenderForm";
import checkboxForm from "./CheckBoxForm";
import fileuploadForm from "./FileuploadForm";
import imageForm from "./ImageForm";
import worktimeForm from "./WorkTimeForm";
import timeinputForm from "./TimeInputForm";
import buttonForm from "./ButtonForm";
import subpageForm from "./subpage/SubpageForm";
import authconfForm from "./AuthconfForm";
import copybuttonForm from "./CopybuttonForm";
import sendbuttonForm from "./SendButtonForm";
import deletebuttonForm from "./DeleteButtonForm";
import autovalueForm from "./AutoValueForm";
import divForm from "./DivForm";
import alldisabledForm from "./AllDisabledForm";
import backbuttonForm from "./BackButtonForm";
import spaceForm from "./SpaceForm";
import qrreaderForm from "./QrReaderForm";
import plainText from "./plainText";
import masterDataForm from "./MasterDataForm";
import masterDataset from "./MasterDataFormV2";
import validationForm from "./VaridatinForm";
import inputchangeForm from "./subpage/inputChangeForm";
import tabTitle from "./tabTitle";
import autoScroll from "./AutoScroll";
import newTab from "./newTab";
export default {
  props: {
    formTypes: Array,
  },
  components: {
    //formを追加するコンポーネント
    formSelectAdd,
    //
    textForm,
    selectForm,
    calenderForm,
    checkboxForm,
    fileuploadForm,
    imageForm,
    worktimeForm,
    timeinputForm,
    buttonForm,
    subpageForm,
    authconfForm,
    copybuttonForm,
    sendbuttonForm,
    deletebuttonForm,
    autovalueForm,
    divForm,
    alldisabledForm,
    backbuttonForm,
    spaceForm,
    qrreaderForm,
    plainText,
    masterDataForm,
    masterDataset,
    validationForm,
    inputchangeForm,
    tabTitle,
    autoScroll,
    newTab,
  },
  data: () => ({
    //
    form: {},
    i: 0,
    j: 0,
    TakeOverFormID: 0,
    //
    formAdd_dialog: false,
    text_dialog: false,
    select_dialog: false,
    calender_dialog: false,
    checkbox_dialog: false,
    fileupload_dialog: false,
    image_dialog: false,
    worktime_dialog: false,
    timeinput_dialog: false,
    button_dialog: false,
    subpage_dialog: false,
    authconf_dialog: false,
    copybutton_dialog: false,
    sendbutton_dialog: false,
    deletebutton_dialog: false,
    autoValue_dialog: false,
    div_dialog: false,
    alldisabled_dialog: false,
    backbutton_dialog: false,
    space_dialog: false,
    qr_dialog: false,
    plain_dialog: false,
    master_dialog: false,
    masterdataset_dialog: false,
    varidasion_dialog: false,
    inputchangeForm_dialog: false,
    tabTitle_dialog: false,
    autoScroll_dialog: false,
    newTab_dialog: false,
    //参照渡しの回避
    checkbox_tmp: {},
  }),
  methods: {
    open(form, i, j) {
      this.form = form;
      this.i = i;
      this.j = j;
      switch (this.form.type) {
        case 0:
          this.TakeOverFormID = this.form.form_id;
          this.formAdd_dialog = true;
          break;
        case 1:
        case 8:
        case 11:
        case 28:
        case 29:
          this.text_dialog = true;
          break;
        case 2:
        case 30:
          this.select_dialog = true;
          break;
        case 3:
          this.calender_dialog = true;
          break;
        case 7:
        case 14:
          //参照渡しの回避
          this.checkbox_tmp = JSON.parse(JSON.stringify(form.checkbox));
          this.checkbox_dialog = true;
          break;
        case 9:
          this.fileupload_dialog = true;
          break;
        case 10:
          this.image_dialog = true;
          break;
        case 12:
          this.worktime_dialog = true;
          break;
        case 15:
          this.timeinput_dialog = true;
          break;
        case 16:
          this.button_dialog = true;
          break;
        case 17:
          this.subpage_dialog = true;
          break;
        case 18:
          this.authconf_dialog = true;
          break;
        case 19:
          this.copybutton_dialog = true;
          break;
        case 20:
          this.sendbutton_dialog = true;
          break;
        case 21:
          alert("ユーザ個別情報フォームで使用");
          break;
        case 22:
          this.deletebutton_dialog = true;
          break;
        case 23:
          this.autoValue_dialog = true;
          break;
        case 24:
          this.div_dialog = true;
          break;
        case 25:
          this.alldisabled_dialog = true;
          break;
        case 26:
          this.backbutton_dialog = true;
          break;
        case 27:
          this.space_dialog = true;
          break;
        case 31:
          this.qr_dialog = true;
          break;
        case 32:
          this.plain_dialog = true;
          break;
        case 33:
          this.master_dialog = true;
          break;
        case 34:
          this.varidasion_dialog = true;
          break;
        //case 35:
        case 36:
          this.inputchangeForm_dialog = true;
          break;
        case 37:
        case 41:
          this.masterdataset_dialog = true;
          break;
        case 38:
          this.tabTitle_dialog = true;
          break;
        case 39:
          this.autoScroll_dialog = true;
          break;
        case 40:
          this.newTab_dialog = true;
          break;
        default:
          console.log("another type:", this.form.type, ":", form);
      }
    },
    close(param) {
      //this.form.position = param.position;
      this.form.cols = param.cols;
      if (typeof param.css != "undefined") {
        this.form.css = param.css;
      }
      console.log("param.css", param.css);
      switch (param.type) {
        case 1:
        case 28:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.form.value = param.value;
          this.text_dialog = false;
          break;
        case 2:
        case 30:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.selectbox = param.selectbox;
          this.form.form_check = param.form_check;
          this.form.rule = param.rule;
          this.select_dialog = false;
          break;
        case 3:
          this.form.label = param.label;
          this.form.value = param.value;
          this.form.rule = param.rule;
          this.calender_dialog = false;
          break;
        case 7:
        case 14:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          console.log(this.form.rule);
          //参照渡しの回避
          this.form.checkbox = JSON.parse(JSON.stringify(param.checkbox));
          this.checkbox_tmp = null;
          this.checkbox_dialog = false;
          break;
        case 8:
        case 29:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.form.size = Number(param.size);
          this.text_dialog = false;
          break;
        case 9:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.file_type = param.file_type;
          this.fileupload_dialog = false;
          break;
        case 10:
          this.form.width = Number(param.width);
          this.form.height = Number(param.height);
          this.form.init = param.init;
          this.image_dialog = false;
          break;
        case 11:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.form.value = param.value;
          this.text_dialog = false;
          break;
        case 12:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.worktime_dialog = false;
          break;
        case 15:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.timeinput_dialog = false;
          break;
        case 16:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.form.color = param.color;
          this.button_dialog = false;
          break;
        case 17:
          this.form.label = param.label;
          this.form.init = param.init; //ページID
          this.form.rule = param.rule; //
          this.form.value = param.value; //ヘッダー情報
          this.subpage_dialog = false;
          break;
        case 18:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.form.value = param.value;
          this.authconf_dialog = false;
          break;
        case 19:
          this.form.label = param.label;
          this.form.color = param.color;
          this.form.value = param.value;
          this.copybutton_dialog = false;
          break;
        case 20:
          this.form.label = param.label;
          this.form.rule = param.rule;
          this.form.color = param.color;
          this.form.init = param.init;
          this.sendbutton_dialog = false;
          break;
        case 22:
          this.form.label = param.label;
          this.form.color = param.color;
          this.form.value = param.value;
          this.form.init = param.init;
          this.deletebutton_dialog = false;
          break;
        case 23:
          this.form.label = param.label;
          this.form.value = param.value;
          this.autoValue_dialog = false;
          break;
        case 24:
        case 34:
          this.form.label = param.label;
          this.form.value = param.value;
          this.form.rule = param.rule;
          this.div_dialog = false;
          this.varidasion_dialog = false;
          break;
        case 25:
          this.form.label = param.label;
          this.form.value = param.value;
          this.form.rule = param.rule;
          this.alldisabled_dialog = false;
          break;
        case 26:
          this.form.label = param.label;
          this.form.value = param.value;
          this.form.rule = param.rule;
          this.backbutton_dialog = false;
          break;
        case 27:
          this.space_dialog = false;
          break;
        case 31:
          this.form.label = param.label;
          this.form.rule = param.rule;
          this.qr_dialog = false;
          break;
        case 32:
          this.form.label = param.label;
          this.form.value = param.value;
          this.form.rule = param.rule;
          this.plain_dialog = false;
          break;
        case 33:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.form.value = param.value;
          this.master_dialog = false;
          break;
        case 36:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.form.value = param.value;
          this.form.init = param.init;
          this.inputchangeForm_dialog = false;
          break;
        case 37:
        case 41:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.form.value = param.value;
          this.form.init = param.init;
          this.masterdataset_dialog = false;
          break;
        case 38:
          this.form.label = param.label;
          this.form.init = param.init;
          this.form.rule = param.rule;
          this.form.init = param.init;
          this.tabTitle_dialog = false;
          break;
        case 39:
          this.form.label = param.label;
          this.form.rule = param.rule;
          this.autoScroll_dialog = false;
          break;
        case 40:
          this.form.label = param.label;
          this.form.rule = param.rule;
          this.form.init = param.init;
          this.newTab_dialog = false;
          break;
        default:
          console.log("another type close");
      }
      this.$emit("clickSubmit", this.form, param.position, this.j);
    },
    formSet(returnData) {
      let obj = returnData.form;
      //モーダルを閉じる
      this.formAdd_dialog = false;
      if (obj.type < -4) {
        let form = returnData.forms;
        form.type = obj.type;
        //親メソッドの実行
        this.$emit("clickSubmit", form, this.i, this.j);
      } else if (obj.type != 0) {
        //登録される変数
        let form = {
          form_id: this.TakeOverFormID,
          //
          type: obj.type,
          name: obj.name,
          label: obj.label,
          cols: obj.cols,
          css: obj.css,
          //テキストボックス
          init: obj.init,
          rule: obj.rule,
          value: obj.value,
          //テキストエリア
          size: obj.size,
          //セレクトボックス
          //--init:  obj.init, //重複
          selectbox: obj.selectbox,
          form_check: false,
          //カレンダー
          //チェックボックス
          checkbox: obj.checkbox,
          //ファイルアップロード
          file_type: obj.file_type,
          //画像欄
          width: obj.width,
          height: obj.height,
          //ボタン
          //コピーボタン
          color: obj.color,
        };
        //親メソッドの実行
        this.$emit("clickSubmit", form, this.i, this.j);
      }
    },
  },
};
</script>
